import { render } from "./CircleFilledIcon.vue?vue&type=template&id=9dbd3788"
const script = {}

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__